export default "__VITE_ASSET__3d2f2c5f__"